<template>
	<v-row no-gutters>
		<v-col cols="12" xs="12" class="px-2">
			<v-autocomplete :search-input.sync="search" v-model="innerValue" small-chips :loading="organizations_loading" chips :label="label" :items="organizations" item-text="label" item-value="value" menu-props="closeOnClick, overflowY">
				<template v-slot:item="data">
					<v-list-item-content>
						<v-list-item-title v-html="data.item.label"></v-list-item-title>
						<v-list-item-subtitle v-html="data.item.description"></v-list-item-subtitle>
					</v-list-item-content>
				</template>
				<template v-slot:no-data v-if="search">
					<v-list-item @click="CreateOrganization(search)">
						<v-list-item-avatar class="my-0">
							<v-icon small>fas fa-plus</v-icon>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title v-html="$t('tenant.organization_not_found')"></v-list-item-title>
							<v-list-item-subtitle v-html="formattedInputCreate"></v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-autocomplete>
			<request-feature v-model="feature" category="organizations" @requestcompleted="showInfoCreated()"></request-feature>
		</v-col>
	</v-row>
</template>

<script>
export default {
	data: () => ({
		innerValue: null,
		search: null,
		feature: null,
	}),
	props: {
		value: {},
		label: {
			type: String,
			default: null,
		},
	},
	computed: {
		formattedInputCreate() {
			return this.$t("tenant.create_organization_text") + " '" + this.search + "' ?";
		},
		organizations() {
			return this.$appOptions.organizations();
		},
		organizations_loading() {
			return this.$store.getters.organizations_loading;
		},
	},
	methods: {
		CreateOrganization(name) {
			this.feature = name;
			this.$store.dispatch("showAction", "showRequestFeature");
		},
		showInfoCreated() {
			this.$store.commit("showDialog", {
				type: "advice",
				title: this.$t("requestfeature.request_completed_title"),
				message: this.$t("requestfeature.request_completed_message"),
			});
		},
	},
	watch: {
		innerValue: {
			handler(newVal) {
				this.$emit("input", newVal);
				this.$nextTick(() => {
					this.$emit("change");
				});
			},
			deep: true,
		},
		value: {
			handler(newVal) {
				this.innerValue = newVal;
			},
			deep: true,
		},
	},
	created() {
		const self = this;
		this.innerValue = _.cloneDeep(this.value);
	},
};
</script>
